export const STAKE_FETCH_POOLS_INFO_BEGIN = 'STAKE_FETCH_POOLS_INFO_BEGIN';
export const STAKE_FETCH_POOLS_INFO_SUCCESS = 'STAKE_FETCH_POOLS_INFO_SUCCESS';
export const STAKE_FETCH_POOLS_INFO_FAILURE = 'STAKE_FETCH_POOLS_INFO_FAILURE';

export const STAKE_CHECK_APPROVAL_BEGIN = 'STAKE_CHECK_APPROVAL_BEGIN';
export const STAKE_CHECK_APPROVAL_SUCCESS = 'STAKE_CHECK_APPROVAL_SUCCESS';
export const STAKE_CHECK_APPROVAL_FAILURE = 'STAKE_CHECK_APPROVAL_FAILURE';

export const STAKE_FETCH_BALANCE_BEGIN = 'STAKE_FETCH_BALANCE_BEGIN';
export const STAKE_FETCH_BALANCE_SUCCESS = 'STAKE_FETCH_BALANCE_SUCCESS';
export const STAKE_FETCH_BALANCE_FAILURE = 'STAKE_FETCH_BALANCE_FAILURE';

export const STAKE_FETCH_CURRENTLY_STAKED_BEGIN = 'STAKE_FETCH_CURRENTLY_STAKED_BEGIN';
export const STAKE_FETCH_CURRENTLY_STAKED_SUCCESS = 'STAKE_FETCH_CURRENTLY_STAKED_SUCCESS';
export const STAKE_FETCH_CURRENTLY_STAKED_FAILURE = 'STAKE_FETCH_CURRENTLY_STAKED_FAILURE';

export const STAKE_FETCH_REWARDS_AVAILABLE_BEGIN = 'STAKE_FETCH_REWARDS_AVAILABLE_BEGIN';
export const STAKE_FETCH_REWARDS_AVAILABLE_SUCCESS = 'STAKE_FETCH_REWARDS_AVAILABLE_SUCCESS';
export const STAKE_FETCH_REWARDS_AVAILABLE_FAILURE = 'STAKE_FETCH_REWARDS_AVAILABLE_FAILURE';

export const STAKE_FETCH_HALF_TIME_BEGIN = 'STAKE_FETCH_HALF_TIME_BEGIN';
export const STAKE_FETCH_HALF_TIME_SUCCESS = 'STAKE_FETCH_HALF_TIME_SUCCESS';
export const STAKE_FETCH_HALF_TIME_FAILURE = 'STAKE_FETCH_HALF_TIME_FAILURE';

export const STAKE_FETCH_CAN_WITHDRAW_TIME_BEGIN = 'STAKE_FETCH_CAN_WITHDRAW_TIME_BEGIN';
export const STAKE_FETCH_CAN_WITHDRAW_TIME_SUCCESS = 'STAKE_FETCH_CAN_WITHDRAW_TIME_SUCCESS';
export const STAKE_FETCH_CAN_WITHDRAW_TIME_FAILURE = 'STAKE_FETCH_CAN_WITHDRAW_TIME_FAILURE';

export const STAKE_FETCH_APPROVAL_BEGIN = 'STAKE_FETCH_APPROVAL_BEGIN';
export const STAKE_FETCH_APPROVAL_SUCCESS = 'STAKE_FETCH_APPROVAL_SUCCESS';
export const STAKE_FETCH_APPROVAL_FAILURE = 'STAKE_FETCH_APPROVAL_FAILURE';

export const STAKE_FETCH_STAKE_BEGIN = 'STAKE_FETCH_STAKE_BEGIN';
export const STAKE_FETCH_STAKE_SUCCESS = 'STAKE_FETCH_STAKE_SUCCESS';
export const STAKE_FETCH_STAKE_FAILURE = 'STAKE_FETCH_STAKE_FAILURE';

export const STAKE_FETCH_WITHDRAW_BEGIN = 'STAKE_FETCH_WITHDRAW_BEGIN';
export const STAKE_FETCH_WITHDRAW_SUCCESS = 'STAKE_FETCH_WITHDRAW_SUCCESS';
export const STAKE_FETCH_WITHDRAW_FAILURE = 'STAKE_FETCH_WITHDRAW_FAILURE';

export const STAKE_FETCH_CLAIM_BEGIN = 'STAKE_FETCH_CLAIM_BEGIN';
export const STAKE_FETCH_CLAIM_SUCCESS = 'STAKE_FETCH_CLAIM_SUCCESS';
export const STAKE_FETCH_CLAIM_FAILURE = 'STAKE_FETCH_CLAIM_FAILURE';

export const STAKE_FETCH_EXIT_BEGIN = 'STAKE_FETCH_EXIT_BEGIN';
export const STAKE_FETCH_EXIT_SUCCESS = 'STAKE_FETCH_EXIT_SUCCESS';
export const STAKE_FETCH_EXIT_FAILURE = 'STAKE_FETCH_EXIT_FAILURE';

export const STAKE_FETCH_POOL_DATA_BEGIN = 'STAKE_FETCH_POOL_DATA_BEGIN';
export const STAKE_FETCH_POOL_DATA_SUCCESS = 'STAKE_FETCH_POOL_DATA_SUCCESS';
export const STAKE_FETCH_POOL_DATA_FAILURE = 'STAKE_FETCH_POOL_DATA_FAILURE';
